import { colorBaseGreyWarm800, colorBaseWhite, layoutMarginSmall } from '@issuu/silkscreen';
import React from 'react';
import styled from 'styled-components';

import { breakpointWidths } from '../../constants';
import Download from './Download';
import Like from './Like';
import Save from './Save';
import Share from './Share';

const Root = styled.div`
    padding: ${layoutMarginSmall};
    border-top: 0.5px solid ${colorBaseWhite};
    color: ${colorBaseWhite};
    background-color: ${colorBaseGreyWarm800};
    display: flex;
    align-items: start;
    justify-content: space-evenly;

    @media (max-width: ${breakpointWidths.tinyMax}px) {
        justify-content: space-between;
    }

    & > * {
        margin: 0 calc(${layoutMarginSmall} * 0.5);

        @media (min-width: ${breakpointWidths.singleColMin}px) {
            margin: 0 calc(${layoutMarginSmall} * 2);
        }

        :first-child {
            margin-left: 0;
        }
        :last-child {
            margin-right: auto;

            @media (max-width: ${breakpointWidths.tinyMax}px) {
                margin-right: 0;
            }
        }
    }
`;

export const DocumentActions: React.FC = () => (
    <Root role="toolbar">
        <Share />
        <Save />
        <Like />
        <Download />
    </Root>
);
